module.exports = __webpack_public_path__ + "static/media/purpleBalloon.2c136181.svg";